<template>
  <div>
    <div v-for="section in text">
      <h2>{{ section.heading }}</h2>
      <p v-html="section.content"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DatalasWidgetText',
  inheritAttrs: false,
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    text: {
      type: Array,
      default: () => [],
    },
  },

  computed: {},
};
</script>
